<template>
  <div class="login">
    <div class="login_box">
      <div class="inputs custom_card">
        <div class="card-header">
          <div class="log-img mb-5">
            <img src="@/assets/images/icons/logo_en.png" width="250" height="80" />
          </div>
          <h4 class="mt-4">{{ $t("auth.title") }}</h4>
          <p>{{ $t("auth.desc") }}</p>
        </div>

        <form class="form form-horizontal" @submit.prevent="validateLoginForm">
          <div class="form-body">
            <div class="row">
              <div class="col-12">
                <!-- START:: EMAIL INPUT -->
                <div class="input_wrapper animated_placeholder top_label">
                  <input
                    type="email"
                    class="form-control"
                    v-model.trim="data.email"
                    :placeholder="$t('forms.labels.email')"
                    @input="helper_checkIfInputIsEmpty"
                  />
                  <label for="login_email" class="form-label">
                    {{ $t("forms.labels.email") }}
                  </label>
                </div>
                <!-- END:: EMAIL INPUT -->

                <!-- START:: PASSWORD INPUT -->
                <div class="input_wrapper animated_placeholder">
                  <label for="login_pass" class="form-label">
                    {{ $t("forms.labels.password") }}
                  </label>

                  <div
                    class="tw-relative tw-flex tw-items-center tw-justify-between"
                  >
                    <input
                      :type="showPassword ? 'text' : 'password'"
                      class="form-control"
                      :placeholder="$t('forms.labels.password')"
                      v-model.trim="data.password"
                      @input="helper_checkIfInputIsEmpty"
                    />
                    <button
                      type="button"
                      class="toggle_pass_btn tw-absolute tw-end-[13px]"
                      @click="showPassword = !showPassword"
                    >
                      <i
                        v-if="showPassword"
                        class="fal fa-eye-slash closed_eye"
                      ></i>
                      <i v-else class="fal fa-eye open_eye"></i>
                    </button>
                  </div>
                </div>
                <!-- END:: PASSWORD INPUT -->
              </div>
            </div>
          </div>
          <div class="tw-flex tw-justify-center tw-items-center">
            <button class="base-btn" :disabled="btnIsLoading">
              {{ $t("forms.login") }}
              <span class="btn_loader" v-if="btnIsLoading"></span>
            </button>
          </div>
        </form>
      </div>

      <!-- Image Side -->
      <div class="image">
        <img src="@/assets/images/pages/login/bg-2.webp" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // Loading
      btnIsLoading: false,
      data: {
        email: null,
        password: null,
      },
      showPassword: false,
    };
  },

  methods: {
    // launch_resize_dispatch() {
    //   this.$store.dispatch("sideNav_module/onResize");
    // },

    validateLoginForm() {
      this.btnIsLoading = true;

      if (!this.data.email) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.email"),
          position: "bottomCenter",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.password) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.password"),
          position: "bottomCenter",
        });
        this.btnIsLoading = false;
        return;
      } else {
        this.submitLoginForm();
      }
    },

    submitLoginForm() {
      const submit_data = new FormData();
      submit_data.append("identifier", this.data.email);
      submit_data.append("password", this.data.password);

      this.axios({
        method: "post",
        url: "login",
        data: submit_data,
      })
        .then((res) => {
          const data = {
            userId: res.data.data.id,
            token: res.data.data.token,
            userImage: res.data.data.image,
            userPhone: res.data.data.phone,
            userType: res.data.data.user_type,
          };

          this.$store.dispatch("auth_module/logIn", data);

          this.$iziToast.success({
            timeout: 2000,
            message: res.response.data.message,
            position: "bottomRight",
          });

          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });

          this.btnIsLoading = false;
        });
    },
  },

  mounted() {
    // if (this.$store.getters.resizeEventExisit == true) {
    //   window.removeEventListener("resize", this.launch_resize_dispatch, true);
    //   this.$store.commit("changeRessizeEvent");
    // }

    document.querySelector("body").style.padding = "0 !important";
  },
};

// <ValidationObserver ref="contactForm" @submit.prevent="submitData">
//           <div class="row">
//             <ValidationProvider
//               v-slot="{ errors }"
//               :name="$t('FORMS.labels.name')"
//               class="col-lg-6"
//               rules="required|min:9|max:11"
//             >
//               <!-- :name="$t('labels.name') + $t('inArabic')" -->
//               <base-input
//                 :name="$t('FORMS.labels.name')"
//                 class=""
//                 :class="errors[0]?'errors':'' "
//                 type="text"
//                 :placeholder="$t('FORMS.Placeholders.name')"
//                 v-model="data.name"
//               />
//               <!-- <base-input
//                 :name="$t('labels.name') + $t('inArabic')"
//                 type="text"
//                 :placeholder="$t('labels.name') + $t('inArabic')"
//                 v-model="data.ar.name"
//               /> -->
//               <span v-if="errors[0]" class="error--text d-inline-block">
//                 {{ errors[0] }}
//               </span>
//             </ValidationProvider>
//           </div>
//           <div class="button_wrapper center">
//             <v-btn
//               type="submit"
//               @click="submitData"
//               :disabled="loading"
//               :loading="loading"
//             >
//               {{ $t('submit') }}
//             </v-btn>
//           </div>
//           <!-- <base-button type="submit" @click="submit" class="center"></base-button> -->
//         </ValidationObserver>
</script>
